import(/* webpackMode: "eager" */ "/app/src/app/[lng]/[...not-found]/page.tsx");
